(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["gp-recommend-products"]) return;
  try {
    
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return '';
  } 
  
  function lusionRecommendedProducts() {
    var time_start = $('.recommended-popup').attr('data-start');
    if(getCookie('gpslus_recommended_product')!='nevershow'){
      setTimeout(function () {
        $('.recommended-products').addClass('active');
      }, time_start);
      
    }
    $('.close-box, .recommended-products .close-popup').on('click', function () {
      $('.recommended-products').removeClass('active');
      closeRecommendedProductsPopup();
    });
  }

  function closeRecommendedProductsPopup(){
    var d = new Date();
    var time_day = $('.recommended-popup').attr('data-day');
    d.setTime(d.getTime() + (time_day));
    var expires = "expires="+d.toUTCString();
    document.cookie = 'gpslus_recommended_product' + "=" + 'nevershow' + "; " + expires;
  }

  $(document).ready(function () {
    $('.recommended-products .product-grid').slick({
        dots: true,
        arrows: false,
        nextArrow: '<i class="theme-iconback"></i>',
        prevArrow: '<i class="theme-iconnext"></i>',
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        dots: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });
    lusionRecommendedProducts();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-content"]) return;
  try {
    
  $(document).ready(function() {
    if ($('.password-page').length > 0) {
      function initCountdown(countdown) {
        var year = parseInt(countdown.data('year'));
        var month = parseInt(countdown.data('month')) - 1;
        var day = parseInt(countdown.data('day'));
        var newDate = new Date(year, month, day );

        var textDay = countdown.data('text-day');
        var textHour = countdown.data('text-hour');
        var textMin = countdown.data('text-min');
        var textSec = countdown.data('text-sec');
        countdown.countdown(newDate, function(event) {
          $(this).html(
            event.strftime('<div><span class="number">%D</span><span class="text">'+ textDay +'</span></div><div><span class="number">%H</span><span class="text">'+ textHour +'</span></div><div><span class="number">%M</span><span class="text">'+ textMin +'</span></div><div><span class="number">%S</span><span class="text">'+ textSec +'</span></div>')
          );
        });
      }
    }
    initCountdown($('.password-page .countdown'))
  }); 

  } catch(e) { console.error(e); }
})();

})();
